export enum NotificationType {
    Default,
    Error,
    Warning,
    Success,
    Update
}
